import styled from 'styled-components';
import {theme} from '@styles/theme';

export const SystemCardWrapper = styled.div`
  display: flex;
  width: 300px;
  flex-direction: column;
  gap: 12px;
  padding: 16px;
  background-color: ${theme.colors.basic08};
  border: 1px solid ${theme.colors.basic06};
  border-radius: ${theme.roundedBig};
`;

export const SystemCardName = styled.div`
  width: 100%;
  span {
    text-overflow: ellipsis;
    overflow: hidden;
    display: block;
    width: 100%;
    white-space: nowrap;
  }
`;

export const SystemCardParamsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const SubsystemsNumWrapper = styled.div`
  display: flex;
  gap: 16px;
`;

export const SubsystemsNum = styled.span`
  display: flex;
  gap: 4px;
`;

export const SystemCardBottomWrapper = styled.span`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const SystemCardLastChangeWrapper = styled.span`
  display: flex;
  flex-direction: column;
`;
